import './blogChapter.css';

const BlogChapter = ({ title, imgUrl, content, id }) => (
  <section className="article-chapter" id={id}>
    <h2>{title}</h2>
    {imgUrl && <img src={imgUrl} className="article-chapter__image" alt="" loading="lazy" />}
    <p>{content}</p>
  </section>
);

export default BlogChapter;
